import { RcFile } from 'antd/lib/upload/interface';
import Request from 'commons/libs/requests';
import { DocumentType } from 'commons/types/documentsTypes';

export async function createDocument(document: RcFile, type: DocumentType) {
  const formData = new FormData();
  formData.append('file', document);
  formData.append('type', type);

  return (
    await Request.post('/api-patients/documents/', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    })
  ).data;
}

export async function deleteDocument(documentID: number) {
  return (await Request.delete(`/api-patients/documents/${documentID}/`)).data;
}

export async function getDocument(documentID: string) {
  const response = await Request.get(`/api/documents/${documentID}/`);
  return response.data;
}

let getDocumentsController: AbortController;

export async function getDocuments(
  params: URLSearchParams,
  cancelPrevious: boolean = true,
) {
  if (cancelPrevious) {
    if (getDocumentsController?.abort) {
      getDocumentsController.abort();
    }

    getDocumentsController = new AbortController();
  }

  const response = await Request.get('/api-patients/documents/', {
    params,
    signal: getDocumentsController.signal,
  });
  return response.data;
}
